import { render, staticRenderFns } from "./FancyVSelect.vue?vue&type=template&id=faf9f91a&scoped=true&"
import script from "./FancyVSelect.vue?vue&type=script&lang=js&"
export * from "./FancyVSelect.vue?vue&type=script&lang=js&"
import style0 from "./FancyVSelect.vue?vue&type=style&index=0&id=faf9f91a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf9f91a",
  null
  
)

export default component.exports